export default __webpack_public_path__ + "static/media/swapping.22ed0ea5.png";